import { render, staticRenderFns } from "./Pto.vue?vue&type=template&id=1b0f6d47&scoped=true"
import script from "./Pto.vue?vue&type=script&lang=js"
export * from "./Pto.vue?vue&type=script&lang=js"
import style0 from "./Pto.vue?vue&type=style&index=0&id=1b0f6d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f6d47",
  null
  
)

export default component.exports